const styles = (theme) => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important",
  }),
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center",
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center",
  },
  tablecontent: {
    color: "black",
    fontSize: "12pt",
    textAlign: "center",
  },
  tab_link: {
    //width: "100px",
    color: "#005795",
    fontSize: "12pt",
    textAlign: "center",
  },
  tablecontent_first: {
    //width: "280px",
    color: "black",
    fontSize: "11pt",
    textAlign: "left",
  },
  tablecontent_status: {
    //width: "40px",
    color: "black",
    fontSize: "12pt",
    textAlign: "center",
  },
  tablecontent_tb: {
    //width: "100px",
    color: "black",
    fontSize: "12pt",
    textAlign: "center",
  },
  tablecontent_last: {
    //width: "100px",
    color: "black",
    fontSize: "12pt",
    textAlign: "center",
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt",
  },
  failState: {
    color: theme.palette.fail,
    //paddingLeft: 30
  },
  passState: {
    color: theme.palette.success,
    //paddingLeft: 30
  },
  div_table1: {
    paddingTop: 30,
  },
  div_table2: {
    height: 300,
    overflow: "auto",
  },
  defaultText: {
    fontSize: "14px",
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "10pt",
    textAlign: "center",
    //width: "280px"
  },
  tableheader_status: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "10pt",
    textAlign: "left",
    //width: "40px"
  },
  tableheader_tb: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "10pt",
    textAlign: "center",
    //width: "100px"
  },
  tableheader_tb2: {
    //fontWeight: "bold",
    color: "black !important",
    fontSize: "10pt",
    textAlign: "center",
    //width: "100px"
  },
  tableheader_last: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "10pt",
    textAlign: "center",
    //width: "100px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px",
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px",
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
  },
  totalGridLast: {
    textAlign: "center",
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px",
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center",
  },
  tab: {
    minWidth: "140px !important",
  },
  table2: {
    overflow: "auto",
    height: 380,
  },
  delayText: {
    color: "black",
    fontSize: "11pt",
    width: "max-content",
  },
  logo: {
    width: "auto",
    height: "50px",
    maxHeight: "50px",
    backgroundColor: "grey",
    border: "1px solid white",
    display: "inline-block",
    maxWidth: "300px",
  },
  polarity: {
    fontSize: "14px",
    paddingTop: "35px",
  },
  summary: {
    padding: theme.spacing.unit,
  },
  tabs: {
    width: "100%",
  },
  bargraph: {
    marginTop: "0px",
    paddingTop: "20px",
  },
  framesize_table: {
    color: "blue underline !important",
  },
  table_prop_delay: {
    "& .td": {
      border: "1px solid #ddd",
      padding: "8px",
    },
    "& .tr": {
      border: "1px solid #ddd",
      padding: "8px",
    },
  },
  infoText: {
    paddingTop: "2px",
    paddingLeft: "3px",
    whiteSpace: "nowrap",
  },
});

export default styles;
